import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { PrivateCompanyLeadData } from "@/features/privateCompanyLeadsFunnel/types/privateCompanyLead";

interface UseCreatePrivateCompanyLeadContractProps {
  id?: string
  privateCompanyLead: PrivateCompanyLeadData
  payload?: object
  onSuccess: () => void
  onError: () => void
}

const useCreatePrivateCompanyLeadContract = ({ id, privateCompanyLead, payload, onSuccess, onError }: UseCreatePrivateCompanyLeadContractProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['createPrivateCompanyLeadContract'],
    mutationFn: async () => {
      const private_company_lead = {
        ...privateCompanyLead,
        contract_attributes: { _create: true, ...payload }
      }

      return privateAxios.put(`/funnel/private_company_leads/${id}`, {
        private_company_lead
      });
    },
    onSuccess,
    onError,
  });
}

export default useCreatePrivateCompanyLeadContract